
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { each } from 'lodash';

import { settings } from '../../app.settings';
import { Segment } from '../../shared/models/segment';
import { BaseService } from '~common/app/shared/services/base.service';
import { AuthService } from '../../auth/services/auth.service';
import { dateRange } from '~common/app/shared/utils/api';
import { NaiveParameterCodec } from '~common/app/shared/utils/encoding';

const API_PATH = settings.api.url + '/programs/me/segments';
const API_PATH_IMPORT = settings.api.url + '/programs/me/consumers/segments';

@Injectable()
export class SegmentService extends BaseService {
  cachedSegments = null;

  constructor(
    private authService: AuthService,
    private http: HttpClient
  ) {
    super();
  }

  fetch(params: any = {}): Observable<any> {
    let apiParams = new HttpParams({ encoder: new NaiveParameterCodec() });

    if (params.cache && this.cachedSegments) {
      return of(this.cachedSegments);
    } else {
      delete params.cache;
    }

    each(params, (value: any, key) => {
      if (key === 'type' && value) {
        if (!Array.isArray(value)) {
          value = [ value ];
        }
        value.forEach((item: string) => {
          apiParams = apiParams.append('type', item);
        });
      } else if (key === 'filters') {
        if (value.term) {
          apiParams = apiParams.append('keyword', value.term );
        }

        if (value.start_date || value.end_date) {
          apiParams = apiParams.append('created_at', dateRange(value.start_date, value.end_date));
        }
      } else if (value || value === 0) {
        apiParams = apiParams.append(key, value);
      }
    });

    return this.http.get(API_PATH, {
      params: apiParams
    }).pipe(map((response) => {
      this.cachedSegments = this.hydrate(Segment, response);
      return this.cachedSegments;
    }));
  }

  get(id): Observable<any > {
    return this.http.get(API_PATH + '/' + id).pipe(map(response => {
      return this.hydrate(Segment, response);
    }));
  }

  getUserCounts(): Observable<{ id: string, count: number }[]> {
    return this.http.get<{ id: string, count: number }[]>(API_PATH + '/users/count');
  }

  getSegmentUrl(id) {
    return API_PATH + '/' + id + '/preview?token=' + this.authService.getToken();
  }

  upload(file: File, params = {}) {
    const formData = new FormData();
    formData.append('file', file);

    Object.keys(params).forEach((key) => {
      formData.append(key, params[key]);
    });

    return this.http.post(API_PATH_IMPORT, formData);
  }
}
